import * as React from "react"

import LogoSvg from "@/images/pingcap-icon.svg"

interface IProps {
  width?: number
  height?: number
}

const Logo: React.FC<IProps> = ({ width, height }) => {
  return <img src={LogoSvg} style={{ width, height }} alt={"PingCAP logo"} />
}

export default Logo
